import { render, staticRenderFns } from "./Assessment.vue?vue&type=template&id=080d3a53&scoped=true"
import script from "./Assessment.vue?vue&type=script&lang=js"
export * from "./Assessment.vue?vue&type=script&lang=js"
import style0 from "./Assessment.vue?vue&type=style&index=0&id=080d3a53&prod&scoped=true&lang=css"
import style1 from "./Assessment.vue?vue&type=style&index=1&id=080d3a53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080d3a53",
  null
  
)

export default component.exports